import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";

import * as componentClasses from "./svelte-components.js";

// @ts-ignore (TODO(@alecglassford): Fix type problems with componentClasses)
hydrate(componentClasses);

// Add your code here! (or write other JS modules and use their imports here)
